function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 4V3a1 1 0 011-1h5.382a1 1 0 01.894.553L8 4h7a1 1 0 011 1v9a1 1 0 01-1 1H1a1 1 0 01-1-1V4zm9.5 4.5V7a1 1 0 10-2 0v1.5H6a1 1 0 100 2h1.5V12a1 1 0 002 0v-1.5H11a1 1 0 000-2H9.5z",
  fill: "#000",
  fillRule: "evenodd"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), _ref);
};

export default SvgComponent;